import { useState } from "react";

import generateOptOutSearchForm from "./generateOptOutSearchForm";

const OptOutSearchForm = ({ onTeaserSearchClick }) => {

  const [reportToken, setReportToken] = useState("");
  const [brandId, setBrandId] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("")
  const [minAge, setMinAge] = useState("18");
  const [maxAge, setMaxAge] = useState("100");

  const clearFields = () => {
    setReportToken('')
    setBrandId('');
    setFirstName('');
    setLastName('');
    setState('');
    setCity('');
    setMinAge('18');
    setMaxAge('100');
  } 
  
  return (
    <div
      className="search-form-box opt-out-search"
      style={{
        background: "#1137535e",
        padding: "1rem",
        borderRadius: "10px",
      }}
    >

      {generateOptOutSearchForm(
        reportToken, setReportToken,
        brandId, setBrandId,
        firstName, setFirstName,
        lastName, setLastName,
        city, setCity,
        state, setState,
        minAge, setMinAge,
        maxAge, setMaxAge
      )}

      <button
        onClick={() =>
          onTeaserSearchClick(
            reportToken,
            brandId,
            firstName,
            lastName,
            city,
            state,
            minAge,
            maxAge
          )
        }
        className="subBtn"
      >
        <span>Submit</span>
      </button>
      <button
        onClick={() =>
          clearFields()
        }
        className="subBtn"
      >
        <span>Clear All Fields</span>
      </button>
    </div>
  );
};

export default OptOutSearchForm;